import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { SwitchTransition, CSSTransition } from 'react-transition-group'

import NavButton from '../NavButton'
import DontKnowButton from '../DontKnowButton'
import OptionButton from '../OptionButton'
import { isHarmony, shuffle } from '../../utils/utils'
import { actions as testActions } from '../../store/test'

import styles from './index.module.css'

export default function Footer() {
  const { stage } = useSelector(state => state.app)
  const { curWord, count, totalCount, showAnwser } = useSelector(
    state => state.test
  )
  const { word, options = [] } = curWord || {}
  const [allStatus, setAllStatus] = useState([])
  const [dontKnowStatus, setDontKnowStatus] = useState(null)
  const [rightIndex, setRightIndex] = useState(-1)
  const [navStatus, setNavStatus] = useState('initial')
  const dispatch = useDispatch()

  useEffect(() => {
    if (stage === 0) {
      const arr = [
        { text: '认识', size: 'small', status: 'initial' },
        { text: '不认识', size: 'small', status: 'initial' },
        { text: '我不确定', size: 'big', status: 'initial' }
      ]
      setAllStatus(arr)
      setNavStatus('initial')
    } else {
      const newOptions = shuffle(options).slice(0, 4)
      let hasRightOption = false
      const arr = newOptions.map((item, idx) => {
        if (item.word === word) {
          hasRightOption = true
          setRightIndex(idx)
        }
        return {
          text: item.mean_cn,
          size: 'small',
          status: 'initial'
        }
      })
      if (!hasRightOption) {
        setRightIndex(arr.length)
      }
      arr.push({
        text: '没有正确答案',
        size: 'big',
        status: 'initial'
      })
      setAllStatus(arr)
      setDontKnowStatus('initial')
      setNavStatus('initial')
    }
  }, [options, stage, word])

  const handleBtnClick = idx => {
    const arr = allStatus.map((item, index) => {
      if (stage === 0 || (stage === 1 && showAnwser === false)) {
        if (index === idx) {
          return {
            ...item,
            status: 'selected'
          }
        } else {
          return {
            ...item,
            status: 'hide'
          }
        }
      } else {
        if (index === rightIndex) {
          return {
            ...item,
            status: 'right'
          }
        }
        if (idx === index && idx !== rightIndex) {
          return {
            ...item,
            status: 'wrong'
          }
        }
        if (idx !== index && index !== rightIndex) {
          return {
            ...item,
            status: 'hide'
          }
        }
      }
    })
    if (stage === 1) setDontKnowStatus('hide')
    setAllStatus(arr)
    setNavStatus('hide')
    dispatch(testActions.goNext(idx, rightIndex))
  }

  const handleDontKnowClick = () => {
    setDontKnowStatus('selected')
    const arr = allStatus.map((item, idx) => {
      if (idx === rightIndex && showAnwser) {
        return {
          ...item,
          status: 'right'
        }
      } else {
        return {
          ...item,
          status: 'hide'
        }
      }
    })
    setAllStatus(arr)
    setNavStatus('hide')
    dispatch(testActions.goNext(5, rightIndex))
  }

  return (
    <div className={styles.root}>
      <SwitchTransition mode='out-in'>
        <CSSTransition key={curWord.word} timeout={250} classNames='trans'>
          <div>
            <div className={styles.optionCntr}>
              {allStatus.map((item, idx) => (
                <OptionButton
                  key={idx}
                  {...item}
                  index={idx}
                  handleBtnClick={handleBtnClick}
                />
              ))}
            </div>
            {stage === 1 && dontKnowStatus && (
              <DontKnowButton
                status={dontKnowStatus}
                handleDontKnowClick={handleDontKnowClick}
              />
            )}
          </div>
        </CSSTransition>
      </SwitchTransition>

      {stage === 0 && <NavButton to='pretest' status={navStatus} />}
      {stage === 1 && count >= totalCount && (
        <NavButton to='test' status={navStatus} />
      )}
      {isHarmony && <div className="safe-bottom"></div>}

    </div>
  )
}
